(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/assets/javascripts/views/listwin.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/assets/javascripts/views/listwin.js');
"use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.map_of_winners.views.ListWin = Marionette.View.extend({
    className: 'list-item',
    template(data) {
      return svs.map_of_winners.templates.listwin(data);
    }
  });
})(Backbone, _, svs);

 })(window);